import React from "react";
import styles from '../styles/Home.module.scss';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import CustomImage from "./CustomImage";
import LazyReveal from "./LazyReveal";

const KcNews: React.FC = (props: any) => {
  const data = props.homePageData;
  const sliderSettings = {
    dots: true,
    dotsClass: styles.kcNewsSliderDots,
    infinite: true,
    autoplay: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    rows: 2,
    slidesPerRow: 4,
    arrows: false,
    responsive: [
      {
        breakpoint: 850,
        settings: {
          slidesPerRow: 3
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesPerRow: 2
        }
      },
    ]
  };

  return (
    <LazyReveal className={styles.kcNews}>
      <Container>
        <Row>
          <div className={styles.heading}>
            <h2>{data?.kcNewsTitle}</h2>
            {data?.kcNewsSubTitle &&
              <p>{data.kcNewsSubTitle}</p>
            }
          </div>
        </Row>
        <Row>
          <Slider {...sliderSettings}>
            {data?.kcNews?.length > 0 &&
              data.kcNews.map((news: any, index: number) => {
                const image = news.image;
                return (
                  <Col className={`${styles.col} ${(Math.floor(index / 4) % 2 !== 0) ? styles.borderBottomMd : ''} ${(Math.floor(index / 3) % 2 !== 0) ? styles.borderBottomSm : ''} ${(Math.floor(index / 2) % 2 !== 0) ? styles.borderBottomXs : ''}`} key={index}>
                    <a href={news.link} target='_blank'>
                      <CustomImage className={styles.img} src={image?.url} alt={image?.alternativeText} width={175} height={75} />
                    </a>
                  </Col>
                )
              })
            }
          </Slider>
        </Row>

      </Container>
    </LazyReveal>
  );
}
export default KcNews;